import { render, staticRenderFns } from "./prospect-list-row.vue?vue&type=template&id=06a8980f"
import script from "./prospect-list-row.vue?vue&type=script&lang=js"
export * from "./prospect-list-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports